import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'angular-web-storage';
import { ToasterService } from 'angular2-toaster';
import * as moment from 'moment';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { EditalDTO } from 'src/app/model/dto/edital.dto';
import { RequerimentoDTO } from 'src/app/model/dto/requerimento.dto';
import { Conta } from 'src/app/model/enum/Conta.enum';
import { TipoChavePix } from 'src/app/model/enum/tipoChavePix.enum';
import { TipoCredito } from 'src/app/model/enum/tipoCredito.enum';
import { TipoCredor } from 'src/app/model/enum/tipoCredor.enum';
import { DataTransferService } from 'src/app/service/data-transfer.service';
import { RequerimentoService } from 'src/app/service/requerimento.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { DocumentoEmitterDTO } from "../../model/dto/DocumentoEmitterDTO";
import { DocumentoDTO } from "../../model/dto/documento.dto";
import { MaskUtil } from '../../utils/mask-util';

const cep = require('cep-promise');


@Component({
    selector: 'app-formulario-solicitacao',
    templateUrl: './formulario-solicitacao.component.html',
    styleUrls: ['./formulario-solicitacao.component.css']
})
export class FormularioSolicitacaoComponent implements OnInit {
    home: string;
    rotaAnterior: string;
    acao: string;
    isViewMode: Boolean = false
    isEdit: Boolean = false
    requerimentoEdit: RequerimentoDTO;
    checked = false;
    indeterminate = false;
    labelPosition = 'after';
    formResultado: FormGroup;
    tipoCredito: TipoCredito;
    tipoCredor: TipoCredor;
    edital: EditalDTO;
    documentos: DocumentoDTO[] = [];
    dataRecebimento: Date;
    date: string;
    minDate = new Date(new Date().getFullYear() - 18);
    tipoCredorInput: number;
    contas: Conta[] = [];
    @BlockUI() blocker: NgBlockUI;
    maxDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

    displayedColumnsDocumentosComprobatorios = ['tipoDocumentoEnum', 'extensao', 'nomeArquivo', 'acao'];
    displayedColumnsOutrosDocumentos = ['descricao', 'extensao', 'nomeArquivo', 'acao'];

    tiposChave = Object.values(TipoChavePix);
    mascaraChavePix: string = '';

    private isDestroyed = false;

    constructor(fb: FormBuilder,
        private dataTransfer: DataTransferService,
        private requerimentoService: RequerimentoService,
        private route: Router,
        private toastService: ToasterService,
        public dialog: MatDialog,
        private router: ActivatedRoute,
        public local: LocalStorageService,
        private cdr: ChangeDetectorRef
    ) {
        this.formResultado = fb.group({
            cpfCnpj: new FormControl('', [Validators.required]),
            nrPrecatorio: new FormControl(''),
            anoOrcamento: new FormControl(''),
            nome: new FormControl(''),
            dtNascimento: new FormControl(''),
            telefone: new FormControl('', [Validators.required]),
            nrConta: new FormControl('', [Validators.required]),
            nrAgencia: new FormControl('', [Validators.required]),
            banco: new FormControl('', [Validators.required]),
            tpConta: new FormControl('', [Validators.required]),
            cedido: new FormControl({ value: 1, disabled: false }),
            tipoCredor: new FormControl(0),
            operacao: new FormControl(''),
            tipoChavePix: new FormControl(''),
            chavePix: new FormControl(''),
            credorOriginario: new FormControl(1),
            nomeCompleto: new FormControl('', [Validators.required]),
            nomeTitular: new FormControl('', [Validators.required]),
            redimentos: new FormControl(0),
            vinculo: new FormControl(0),
            situacao: new FormControl(0),
            orgao: new FormControl(0),
            numeroMeses: [0, [Validators.min(0)]],
            idProcessoRendimento: new FormControl('', [
                Validators.pattern(/^[0-9]*$/),
                Validators.maxLength(8),
                Validators.minLength(8)
            ]),
            idProcessoSituacao: new FormControl('', [
                Validators.pattern(/^[0-9]*$/),
                Validators.maxLength(8),
                Validators.minLength(8)
            ]),
            idProcessoOrgao: new FormControl('', [
                Validators.pattern(/^[0-9]*$/),
                Validators.maxLength(8),
                Validators.minLength(8)
            ]),

            tipoCredito: new FormControl(0),
            cpfCnpjRequerente: new FormControl(''),

            outroorgao: new FormControl(''),




        })


    }

    ngOnInit() {
        this.preencherCampos();
        this.verificarRota();
        Object.values(Conta).forEach(conta => this.contas.push(conta));
        this.rotaAnterior = this.local.get('rotaAnterior');
        this.home = this.local.get('home');

        this.formResultado.get('tipoChavePix').valueChanges.subscribe((tipoChavePix: TipoChavePix) => {
            this.configurarValidacaoChavePix(tipoChavePix);
        });

        this.formResultado.get('tipoChavePix').valueChanges.subscribe(tipoChave => {
            this.atualizarMascara(tipoChave);
        });
    }

    ngAfterViewInit(): void {
        this.formResultado.get('tipoChavePix').updateValueAndValidity();
        this.formResultado.get('chavePix').updateValueAndValidity();
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }

    verificarRota() {

        this.router.paramMap.subscribe(params => {
            this.acao = params.get('acao');
        });

        this.router.params.subscribe(({ idRequerimento }) => {
            if (idRequerimento) {
                this.dataTransfer.currentValue.subscribe((precatorio: RequerimentoDTO) => {
                    const periodoFimDate = new Date(precatorio.edital.periodoFim);
                    const isEditing = periodoFimDate > new Date() && this.acao === 'editar';
                    this.isViewMode = !isEditing;
                    this.isEdit = isEditing;
                    this.requerimentoEdit = precatorio;
                    this.atualizarEstadoControles();
                    this.preencherCamposEditavel(precatorio);
                });
            }
        });

    }

    atualizarEstadoControles(): void {
        const controls = this.formResultado.controls
        if (this.isViewMode) {
            this.desabilitarControles(controls);
        } else {
            this.habilitarControles(controls);
        }
    }

    habilitarControles(controls: { [key: string]: AbstractControl }): void {
        Object.keys(controls).forEach(key => {
            if (key !== 'tipoCredito') controls[key].enable();
        });
    }

    desabilitarControles(controls: { [key: string]: AbstractControl }): void {
        Object.keys(controls).forEach(key => controls[key].disable());
    }


    preencherCamposEditavel(requerimento: RequerimentoDTO) {
        const tipoCredorValue = Number(TipoCredor[requerimento.credor.tipoCredor]);
        if (requerimento.credor.dataNascimento) {
            this.formResultado.get('dtNascimento').setValue(
                moment(requerimento.credor.dataNascimento).format('DD/MM/YYYY')
            );
        } else {
            this.formResultado.get('dtNascimento').setValue(null);
        }
        this.formResultado.get('telefone').setValue(requerimento.credor.contato)
        this.formResultado.get('tipoCredor').setValue(tipoCredorValue)
        this.formResultado.get('banco').setValue(requerimento.credor.dadosBancarios.banco)
        this.formResultado.get('tpConta').setValue(Conta[requerimento.credor.dadosBancarios.tipoConta])
        this.formResultado.get('operacao').setValue(requerimento.credor.dadosBancarios.operacao)
        this.formResultado.get('nrAgencia').setValue(requerimento.credor.dadosBancarios.agencia)
        this.formResultado.get('nrConta').setValue(requerimento.credor.dadosBancarios.numeroConta)
        this.formResultado.get('tipoChavePix').setValue(requerimento.credor.dadosBancarios.tipoChavePix)
        this.formResultado.get('chavePix').setValue(requerimento.credor.dadosBancarios.chavePix)
        this.formResultado.get('cpfCnpjRequerente').setValue(this.aplicarMascaraCnpjCpf(requerimento.credor.cpfCnpjRequerente));
        this.formResultado.get('credorOriginario').setValue(requerimento.credor.credorOriginario);
        this.formResultado.get('nomeCompleto').setValue(requerimento.credor.nomeCompleto);
        this.formResultado.get('nomeTitular').setValue(requerimento.credor.dadosBancarios.nomeTitular);
        this.formResultado.get('redimentos').setValue(requerimento.redimentos);
        this.formResultado.get('vinculo').setValue(requerimento.vinculo);
        this.formResultado.get('situacao').setValue(requerimento.situacao);
        this.formResultado.get('orgao').setValue(requerimento.orgao);
        this.formResultado.get('numeroMeses').setValue(requerimento.numeroMeses);
        this.formResultado.get('idProcessoRendimento').setValue(requerimento.idProcessoRendimento);
        this.formResultado.get('idProcessoSituacao').setValue(requerimento.idProcessoSituacao);
        this.formResultado.get('idProcessoOrgao').setValue(requerimento.idProcessoOrgao);
        this.formResultado.get('cedido').setValue(requerimento.credor.cedido);
        this.formResultado.get('outroorgao').setValue(requerimento.outroorgao);



        /*  requerimento.documentos.forEach(documento => {
              const documentoEmitterDTO: DocumentoEmitterDTO = {
                  documento: documento,
                  acao: 'INCLUIR'
              };
              this.pegarDocumentos(documentoEmitterDTO);
          });
  */



        this.atualizarMascara(requerimento.credor.dadosBancarios.chavePix);
    }

    private atualizarMascara(tipoChave: string): void {
        this.mascaraChavePix = this.getMascaraPorTipo(tipoChave);
        if (!this.isDestroyed) {
            this.cdr.detectChanges();
        }
    }

    preencherCampos() {
        this.dataTransfer.currentValue.subscribe((precatorio: RequerimentoDTO) => {
            this.edital = precatorio.edital;
            this.dataRecebimento = precatorio.dataRecebimento ? precatorio.dataRecebimento : precatorio.dataCadastro;
            this.formResultado.get('nrPrecatorio').setValue(precatorio.numPrecatorio);
            this.formResultado.get('nome').setValue(precatorio.credor.nome);
            this.formResultado.get('anoOrcamento').setValue(precatorio.anoOrcamento);
            this.formResultado.get('tipoCredito').setValue(this.selecionarTipoCredito(precatorio.tipoCredito))
            this.formResultado.get('cpfCnpj').setValue(precatorio.credor.cpfCnpj != null ? this.aplicarMascaraCnpjCpf(precatorio.credor.cpfCnpj) : precatorio.credor.cpfCnpj);
            // Novos Campos
            this.formResultado.get('cpfCnpjRequerente').setValue(this.aplicarMascaraCnpjCpf(precatorio.credor.cpfCnpjRequerente));
            this.formResultado.get('nomeCompleto').setValue(precatorio.credor.nomeCompleto);


        });
    }

    aplicarMascaraCnpjCpf(valor: string) {
        if (valor.length <= 11) {
            return MaskUtil.cpfToMask(valor);
        } else if (valor.length === 14) {
            return MaskUtil.cnpjToMask(valor);
        } else {
            return valor;
        }
    }

    validarFormulario(): void {
        const tipoChave = this.formResultado.get('tipoChavePix').value;
        const chavePix = this.formResultado.get('chavePix').value;

        if (chavePix) {
            if (tipoChave === 'CPF' && !MaskUtil.validar_cpf(chavePix)) {
                this.formResultado.get('chavePix').setErrors({ invalidCpf: true });
            } else if (tipoChave === 'CNPJ' && !MaskUtil.validar_cnpj(chavePix)) {
                this.formResultado.get('chavePix').setErrors({ invalidCnpj: true });
            } else {
                this.formResultado.get('chavePix').setErrors(null);
            }
        }

        this.formResultado.get('chavePix').markAsTouched();


    }

    exibirCampoChave(): boolean {
        const tipoChavePix = this.formResultado.get('tipoChavePix').value;
        return tipoChavePix === TipoChavePix.CPF || tipoChavePix === TipoChavePix.CNPJ;
    }

    configurarValidacaoChavePix(tipoChave: TipoChavePix): void {
        const chavePixControl = this.formResultado.get('chavePix');

        if (tipoChave) {
            chavePixControl.setValidators([Validators.required]);
        } else {
            chavePixControl.clearValidators();
        }
        chavePixControl.updateValueAndValidity();
    }

    private getMascaraPorTipo(tipoChave: string): string {
        switch (tipoChave) {
            case 'CPF':
                return '000.000.000-00';
            case 'CNPJ':
                return '00.000.000/0000-00';
            default:
                return '';
        }
    }

    guardarData(event) {
        var timeDiff = Math.abs(Date.now() - new Date(event.value).getTime());
        const age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);

        this.date = moment(event.targetElement.value, 'DD/MM/YYYY').locale('en-ca').format('L');
    }

    solicitar() {
        this.montarRequerimento();
    }

    montarRequerimento() {
        this.markAllAsTouched();
        this.validarFormulario();
        const pessoa = this.formResultado.get('cpfCnpjRequerente').value.replace(/[^0-9a-zA-Z]+/g, '');
        if (this.formResultado.get('redimentos').value === 1 && this.formResultado.get('numeroMeses').value < 1) {
            this.toastService.pop('warning', 'Preencha o número de meses.')
            return;
        }

        if (this.formResultado.get('orgao').value === 0) {
            this.toastService.pop(
                'warning',
                'Selecione um Órgão do Estado da Bahia a que pertence o(a) beneficiário(a) originário(a)'
            );
            return;
        }
        if (this.formResultado.get('orgao').value === 10 && (this.formResultado.get('outroorgao').value === null || this.formResultado.get('outroorgao').value === '')) {
            this.toastService.pop(
                'warning',
                'Digite a descrição do outro Órgão do Estado da Bahia a que pertence o(a) beneficiário(a) originário(a)'
            );
            return;
        }


        if (!this.formResultado.valid) {
            this.toastService.pop('warning', 'Preencha todos os campos')
            return;
        }
        if (this.documentos.length < 0) {
            this.toastService.pop('warning', 'Adicione todos os documentos')
            return;
        }

        if (this.documentos.length != 0) {
            const tipoDocumento = this.documentos.filter(doc => doc.tipoDocumento.id === 7 || doc.tipoDocumento.id === 8);
            if (tipoDocumento.length > 0) {
                this.toastService.pop('warning', 'Adicione todos os documentos');
                return;
            }
        }


        this.blocker.start('Processando...');

        const valorDtNascimento = this.formResultado.get('dtNascimento').value;
        let dataNascimentoFormatada: string | null = null; // Inicializa como null

        if (valorDtNascimento) { // Se o campo não está vazio
            const dataMoment = moment(valorDtNascimento, 'DD/MM/YYYY');

            if (dataMoment.isValid()) { // Verifica se o Moment.js conseguiu parsear a data corretamente
                dataNascimentoFormatada = dataMoment.locale('en-ca').format('L'); // Isso resultará em 'YYYY-MM-DD'
            } else {
                // Se a data do formulário for inválida, 'dataNascimentoFormatada' permanece null, 
                // ou você pode logar um aviso para ajudar na depuração.
                console.warn('Data de Nascimento inválida no frontend:', valorDtNascimento);
            }
        }

        const requerimento = {
            id: this.requerimentoEdit ? this.requerimentoEdit.id : '',
            credor: {
                id: this.requerimentoEdit ? this.requerimentoEdit.credor.id : '',
                nome: this.formResultado.get('nome').value,
                cpfCnpj: this.formResultado.get('cpfCnpj').value.replace(/[^0-9a-zA-Z]+/g, ''),
                cpfCnpjRequerente: this.formResultado.get('cpfCnpjRequerente').value.replace(/[^0-9a-zA-Z]+/g, ''),

                dataNascimento: dataNascimentoFormatada, 
                contato: this.formResultado.get('telefone').value,
                tipoCredor: this.selecionarCredor(this.tipoCredorInput),

                // Novos campos do credor DM#14192:
                credorOriginario: this.formResultado.get('credorOriginario').value,
                nomeCompleto: this.formResultado.get('nomeCompleto').value,
                cedido: this.formResultado.get('cedido').value,



                dadosBancarios: {
                    id: this.requerimentoEdit ? this.requerimentoEdit.credor.dadosBancarios.id : '',
                    numeroConta: this.formResultado.get('nrConta').value,
                    tipoConta: this.pegarTipoContas(this.formResultado.get('tpConta').value),
                    agencia: this.formResultado.get('nrAgencia').value,
                    banco: this.formResultado.get('banco').value,
                    operacao: this.formResultado.get('operacao').value,
                    tipoChavePix: this.formResultado.get('tipoChavePix').value,
                    chavePix: this.formResultado.get('tipoChavePix').value ? this.formResultado.get('chavePix').value : '',
                    // Novo campos do credor DM#14192:
                    nomeTitular: this.formResultado.get('nomeTitular').value,
                }
            },
            //Novos campos DM#14192:


            redimentos: this.formResultado.get('redimentos').value,
            vinculo: this.formResultado.get('vinculo').value,
            situacao: this.formResultado.get('situacao').value,
            orgao: this.formResultado.get('orgao').value,


            numeroMeses: this.formResultado.get('redimentos').value === 1 ? this.formResultado.get('numeroMeses').value : 0,

            idProcessoRendimento: this.formResultado.get('redimentos').value === 1 ? this.formResultado.get('idProcessoRendimento').value : null,

            idProcessoSituacao: this.formResultado.get('situacao').value === 3 ? this.formResultado.get('idProcessoSituacao').value : null,

            idProcessoOrgao: this.formResultado.get('orgao').value !== 0 ? this.formResultado.get('idProcessoOrgao').value : null,

            outroorgao: this.formResultado.get('orgao').value === 10 ? this.formResultado.get('outroorgao').value : '',





            numPrecatorio: this.formResultado.get('nrPrecatorio').value,
            tipoCredito: this.formResultado.get('tipoCredito').value,
            anoOrcamento: this.formResultado.get('anoOrcamento').value,
            edital: this.edital,
            dataRecebimento: this.dataRecebimento,
            idAdvogado: this.local.get('idUsuario')
        };
        requerimento.tipoCredito = this.pegarTipoCredito(requerimento.tipoCredito);
        this.salvar(requerimento);
    }

    markAllAsTouched() {
        Object.keys(this.formResultado.controls).forEach(key => {
            const control = this.formResultado.get(key);
            if (control) {
                control.markAsTouched();
            }
        });
    }

    salvar(requerimento: any) {
        if (this.isEdit) {
            this.requerimentoService.editarDocumentos(requerimento, this.documentos).subscribe(response => {
                if (response.data !== null) {
                    this.blocker.stop();
                    Swal.fire('Confirmação', response.mensagem);
                    this.route.navigate([this.home]);
                }
            }, err => {
                this.blocker.stop();
                Swal.fire('Erro', 'Deu erro ao enviar formulário.');
            });
        } else {
            this.requerimentoService.salvarDocumentos(requerimento, this.documentos).subscribe(response => {
                if (response.data !== null) {
                    this.blocker.stop();
                    Swal.fire('Confirmação', response.mensagem + ' ' + response.data.numFormulario);
                    this.route.navigate([this.home]);
                }
            }, err => {
                this.blocker.stop();
                Swal.fire('Erro', 'Deu erro ao enviar formulário.');
            });
        }
    }

    pegarTipoContas(value) {
        if (value === 'Poupança') {
            return 'POUPANCA';
        }
        if (value === 'Corrente') {
            return 'CORRENTE';
        }
    }

    pegarDocumentos(documentoEmitterDTO: DocumentoEmitterDTO) {
        if (documentoEmitterDTO.acao.toUpperCase() === 'INCLUIR') {
            this.documentos.push(documentoEmitterDTO.documento);
        } else if (documentoEmitterDTO.acao.toUpperCase() === 'EXCLUIR') {
            this.documentos.splice(this.documentos.indexOf(documentoEmitterDTO.documento), 1);
        }
    }



    selecionarTipoDocumento(event) {
        this.tipoCredorInput = event.value;
    }

    cancelar() {
        this.route.navigate([this.rotaAnterior]);
    }

    public cpfcnpjmask = function (rawValue) {
        var numbers = rawValue.match(/\d/g);
        var numberLength = 0;
        if (numbers) {
            numberLength = numbers.join('').length;
        }
        if (numberLength <= 11) {
            return [
                /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/,];
        } else {
            return [
                /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-',
                /[0-9]/, /[0-9]/,];
        }
    };
    public precatoriomask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
    public numContaMask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
    public cepMask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/];

    selectFile() {
        let element: HTMLElement = document.querySelector('input[type="file"]') as HTMLElement;
        element.click();
    }

    private selecionarTipoCredito(value: TipoCredito) {
        if (value.toString() === "ALIMENTAR") {
            return 1;
        } else {
            return 0;
        }
    }

    private pegarTipoCredito(value: number) {
        if (value === 0) {
            return 'COMUM'
        } else {
            return 'ALIMENTAR'
        }
    }

    private selecionarCredor(value: number) {
        if (value === 1) {
            return TipoCredor.SUCESSOR
        }
        if (value === 0 || value === undefined) {
            return TipoCredor.ORIGINARIO
        }
        if (value === 3) {
            return TipoCredor.CESSIONARIO
        }
    }

    onRedimentosChange() {

    }
    onSituacaoChange() {

    }
    onOrgaoChange() {

    }
    onVinculoChange() {

    }


}
